import { useEffect } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { useTheme } from './useTheme';

/**
 * iOS status bar that adapts to theme (light/dark mode)
 * - Light mode: Dark text on light background (Style.Light)
 * - Dark mode: Light text on dark background (Style.Dark)
 */
export function useIOSStatusBar() {
  const { theme, isDarkMode } = useTheme();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const setStatusBar = async () => {
      try {
        // iOS Style interpretation (CORRETO):
        // Style.Dark = light text on dark background (PARA DARK MODE)
        // Style.Light = dark text on light background (PARA LIGHT MODE)
        const style = isDarkMode ? Style.Dark : Style.Light;
        const backgroundColor = isDarkMode ? '#000000' : '#FFFFFF';
        
        await StatusBar.setStyle({ style });
        await StatusBar.setBackgroundColor({ color: backgroundColor });
        await StatusBar.show();
      } catch (error) {
        console.warn('[useIOSStatusBar] Failed to set status bar:', error);
      }
    };

    setStatusBar();
  }, [theme, isDarkMode]);
}
